import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-qsxy_icon",
  "use": "icon-qsxy_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-qsxy_icon\">\n<title>qsxy_icon</title>\n<path d=\"M27.429 2.286v13.714h-2.286v-11.429h-20.574v22.857h8.032v2.286h-10.316v-27.429z\" />\n<path d=\"M23.464 18.312l1.617 1.616-6.463 6.467-1.617-1.616z\" />\n<path d=\"M25.143 27.429v2.286h-9.143v-2.286z\" />\n<path d=\"M21.714 8v2.286h-13.714v-2.286z\" />\n<path d=\"M17.143 13.714v2.286h-9.143v-2.286z\" />\n<path d=\"M12.571 20.571v2.286h-4.571v-2.286z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol